import React from 'react';
import { Grid, Table, Button, Form, TextArea } from 'semantic-ui-react';
import InputField from 'common/InputField';


const QuestLogEditor = function(props) {
  const questlog = props.questlog;
  const change = props.onChange;

  const removeNode = function(i) {
    change('Node')(questlog.Node.filter((n, idx) => idx !== i));
  }

  const addNode = function() {
    const newNode = {
      ID: '',
      Text: ''
    };

    change('Node')([...questlog.Node, newNode]);
  }

  return (
  <React.Fragment>
    <Grid.Row>
      <Grid.Column width={16}>
        <Table celled striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={4}>ID</Table.HeaderCell>
              <Table.HeaderCell width={12}>Text</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {questlog.Node.map((n, i) => {

              const changeNode = (f) => {
                return function(val) {
                  let newNode = {...n};
                  newNode[f] = val;
                  let allNodes = [...questlog.Node];
                  allNodes[i] = newNode;
                  change('Node')(allNodes);
                }
              }

              return (
                <Table.Row>
                  <Table.Cell>
                    <InputField value={n.ID}
                                onChange={changeNode('ID')}
                                placeholder='ID'
                                label='ID'
                                type='ID' />
                    <Button icon='delete'
                            color='red'
                            onClick={() => removeNode(i)} />
                  </Table.Cell>
                  <Table.Cell>
                    <Form>
                      <TextArea value={n.Text}
                                onChange={(e,d) => changeNode('Text')(d.value)}
                                />
                    </Form>
                  </Table.Cell>
                </Table.Row>
              )
            })}
          </Table.Body>
        </Table>
        <Button icon='add' content='Add node' onClick={addNode} />
      </Grid.Column>
    </Grid.Row>
  </React.Fragment>
  );
}



export default QuestLogEditor;
